import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { CarrierType } from '../../const';
import styles from './style/index.less';
var teleComAgreement = 'https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=true&returnUrl=';
var unicomAgreement = 'https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true';
export var Agreement = function (props) {
    var Text = useComponents().Text;
    var carrierType = props.carrierType;
    var handleJumpUrl = function (url) { return (window.location.href = url); };
    return (React.createElement(React.Fragment, null,
        carrierType === CarrierType.dianxin && (React.createElement(Text, { onClick: function () { return handleJumpUrl(teleComAgreement); }, className: styles['authorize-phone-tip-link'], content: "\u300A\u5929\u7FFC\u8D26\u53F7\u670D\u52A1\u4E0E\u9690\u79C1\u534F\u8BAE\u300B" })),
        carrierType === CarrierType.liantong && (React.createElement(Text, { onClick: function () { return handleJumpUrl(unicomAgreement); }, className: styles['authorize-phone-tip-link'], content: "\u300A\u8054\u901A\u7EDF\u4E00\u8BA4\u8BC1\u670D\u52A1\u6761\u6B3E\u300B" }))));
};
